export default function Input({
  label,
  type = 'text',
  value,
  onChange,
  placeholder,
  required = false,
  error,
  className = '',
  ...props
}) {
  return (
    <div className={`form-group ${className}`}>
      {label && (
        <label className="form-label">
          {label} {required && '*'}
        </label>
      )}
      <input
        type={type}
        className="form-input"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        {...props}
      />
      {error && (
        <span style={{ fontSize: 10, color: 'var(--danger)', marginTop: 4 }}>
          {error}
        </span>
      )}
    </div>
  )
}

export function MoneyInput({ value, onChange, placeholder, ...props }) {
  const fmtN = (n) => {
    if (n == null || isNaN(n)) return '0'
    return Number(n).toLocaleString('id-ID')
  }
  
  const pN = (s) => {
    if (typeof s === 'number') return s
    return parseInt(String(s).replace(/\D/g, ''), 10) || 0
  }
  
  const raw = pN(value)
  const display = raw ? fmtN(raw) : ''
  
  return (
    <div className="money-input-wrap">
      <span className="prefix">Rp</span>
      <input
        className="form-input"
        type="text"
        inputMode="numeric"
        value={display}
        onChange={(e) => onChange(parseInt(e.target.value.replace(/\D/g, ''), 10) || 0)}
        placeholder={placeholder || '0'}
        {...props}
      />
    </div>
  )
}

export function NumInput({ value, onChange, placeholder, ...props }) {
  const fmtN = (n) => {
    if (n == null || isNaN(n)) return '0'
    return Number(n).toLocaleString('id-ID')
  }
  
  const pN = (s) => {
    if (typeof s === 'number') return s
    return parseInt(String(s).replace(/\D/g, ''), 10) || 0
  }
  
  const raw = pN(value)
  const display = raw ? fmtN(raw) : ''
  
  return (
    <input
      className="form-input"
      type="text"
      inputMode="numeric"
      value={display}
      onChange={(e) => onChange(parseInt(e.target.value.replace(/\D/g, ''), 10) || 0)}
      placeholder={placeholder || '0'}
      {...props}
    />
  )
}

export function Select({ label, value, onChange, options, className = '', ...props }) {
  return (
    <div className={`form-group ${className}`}>
      {label && <label className="form-label">{label}</label>}
      <select
        className="form-select"
        value={value}
        onChange={onChange}
        {...props}
      >
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  )
}